module.exports = __webpack_public_path__ + "static/media/logo-plus.6580a2e5.svg";